import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { constants } from '../../../src/app/home/reports/constants/constants';
import * as moment from 'moment';


@Injectable()
export class InvalidUserService {

    count = 0;
    firstHitTime: any;
    hitCount: number;
    currentTime: number
    resetCount: number
    

  constructor(private cookieService: CookieService) { }

  resetCounter(){
      this.count = 0;
      this.cookieService.set('HitCount', this.count.toString());
  }

  incrementcounter(){
    this.hitCount =  this.count += 1 
    this.setCounter();
  }

  setCounter(){    
    if(this.hitCount == 1 ){
    this.cookieService.set('HitCount', this.hitCount.toString());
    var date = new Date();
    this.cookieService.set('HitTime', date.toString());
    }
  }


  validateTime(hitcount:number, duration): boolean{
      if( hitcount > 4 &&  duration > constants.INVALIDHITTIME.HITTIME){
       this.resetCounter();
        this.cookieService.delete('HitTime');
        return true;
      }
      if(hitcount < 4 && duration > constants.INVALIDHITTIME.HITTIME){
         return true;
      }
      if(hitcount > 4 && duration < constants.INVALIDHITTIME.HITTIME){
        return false;
     }

     return true;
  }



  getTimeDuration(C: number){
    let date = new Date();
    let firstHitTime =  this.cookieService.get('HitTime');
    let diff = moment.duration(moment(date).diff(moment(firstHitTime)));
    let duration = diff.asMinutes();
    this.currentTime =  duration;
  }

  validateLoginRequest(): boolean {
    if (this.count > 0) {
      this.getTimeDuration(this.count);
      return this.validateTime(this.count, this.currentTime)
    } else {
      return true;
    }

  } 

}